import axios from 'axios';
import { API_BASE_URL } from '../../confing.js/baseUrl';
import apiClient from '../../services/apiClient';



// add new order
const addOrder = async (orderData) => {
	const response = await apiClient.post('/api/orders/', orderData);

	return response.data;
};

// Get all orders
const getAllorders = async () => {


	const response = await apiClient.get('/api/orders/');
	return response.data;
};
// Get single order
const getOrder = async (orderId) => {
	//   const config = {
	//     headers: {
	//       Authorization: `Bearer ${token}`,
	//     },
	//   }

	const response = await apiClient.get(`/api/orders/${orderId}`);

	return response.data;
};

// Delete single  appointment
const deleteOrder = async (orderId) => {
	//   const config = {
	//     headers: {
	//       Authorization: `Bearer ${token}`,
	//     },
	//   }

	const response = await apiClient.delete(`/api/orders/${orderId}`);

	return response.data;
};
// edit single order 
const updateOrder = async (orderId) => {
	//   const config = {
	//     headers: {
	//       Authorization: `Bearer ${token}`,
	//     },
	//   }

	const response = await apiClient.put(`/api/orders/${orderId}`);

	return response.data;
};

const orderservice = {
	addOrder,
	getAllorders,
	deleteOrder,
	updateOrder,
	getOrder
};

export default orderservice;
